<script>
  import { auth } from '../lib/stores/auth.svelte.js';

  let email = $state('');
  let token = $state('');
  let mode = $state('idle'); // idle | otp_sent | verifying

  async function sendOtp() {
    if (!email) return;
    const ok = await auth.sendOtp(email);
    if (ok) mode = 'otp_sent';
  }

  async function verifyOtp() {
    if (!email || !token) return;
    mode = 'verifying';
    const ok = await auth.verifyOtp(email, token);
    if (!ok) mode = 'otp_sent';
  }

  function signInWithGoogle() {
    auth.signInWithGoogle();
  }
</script>

<div class="login-page">
  <div class="login-card">
    <div class="login-brand">
      <img src="https://res.cloudinary.com/dj0spw2w8/image/upload/v1767931182/BLV_Secondary_Logo_Profile_Picture_ou6q5d.png" alt="BLV" class="login-logo" />
      <h1 class="login-title">BLV Business Builder</h1>
      <p class="login-tagline">Take what's in your head and build a model people actually want.</p>
    </div>

    <button class="google-btn" onclick={signInWithGoogle}>
      <svg class="google-icon" viewBox="0 0 24 24" width="18" height="18">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
      </svg>
      Continue with Google
    </button>

    <div class="divider">or</div>

    {#if mode === 'idle'}
      <input class="email-input" type="email" placeholder="you@email.com" bind:value={email} />
      <button class="send-code-btn" onclick={sendOtp} disabled={!email}>Send code</button>
    {:else}
      <input class="email-input" type="email" placeholder="you@email.com" bind:value={email} disabled />
      <input class="email-input" type="text" placeholder="6-digit code" bind:value={token} maxlength="6" />
      <button class="send-code-btn" onclick={verifyOtp} disabled={mode === 'verifying' || !token}>
        {mode === 'verifying' ? 'Verifying…' : 'Verify'}
      </button>
      <button class="link" onclick={() => { mode = 'idle'; token = ''; }}>Use a different email</button>
    {/if}

    {#if auth.error}
      <div class="error">{auth.error}</div>
    {/if}
  </div>
</div>

<style>
  :global(body) {
    background:
      radial-gradient(ellipse at top left, rgba(212,175,55,0.06), transparent 50%),
      radial-gradient(ellipse at bottom right, rgba(122,184,255,0.04), transparent 50%),
      linear-gradient(180deg, #0a0a0c 0%, #050507 100%);
    background-attachment: fixed;
  }
  .login-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
  }
  .login-card {
    background: rgba(18,18,22,0.6);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    padding: 48px 40px;
    max-width: 420px;
    width: 100%;
    box-shadow:
      0 20px 80px rgba(0,0,0,0.5),
      0 0 0 1px rgba(255,255,255,0.02),
      inset 0 1px 0 rgba(255,255,255,0.06);
    animation: fadeUp 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .login-brand {
    text-align: center;
    margin-bottom: 32px;
  }
  .login-logo {
    height: 56px;
    width: auto;
    margin-bottom: 20px;
    filter: drop-shadow(0 4px 24px rgba(212,175,55,0.2));
  }
  .login-title {
    color: #f4f4f6;
    font-size: 22px;
    font-weight: 600;
    margin: 0 0 8px;
    letter-spacing: -0.01em;
  }
  .login-tagline {
    color: #888892;
    font-size: 13px;
    margin: 0;
    line-height: 1.5;
  }
  .google-btn {
    width: 100%;
    background: #ffffff;
    color: #1a1a1a;
    border: none;
    padding: 12px 20px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: transform 0.1s ease, box-shadow 0.2s ease;
    box-shadow: 0 2px 12px rgba(0,0,0,0.3);
  }
  .google-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 20px rgba(255,255,255,0.1);
  }
  .google-icon { display: block; }
  .divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 24px 0;
    color: #56565c;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1.2px;
  }
  .divider::before, .divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(255,255,255,0.08);
  }
  .email-input {
    width: 100%;
    background: rgba(0,0,0,0.4);
    border: 1px solid rgba(255,255,255,0.1);
    color: #f4f4f6;
    padding: 12px 14px;
    border-radius: 10px;
    font-size: 14px;
    margin-bottom: 12px;
    box-sizing: border-box;
    transition: border-color 0.15s ease;
  }
  .email-input:focus {
    outline: none;
    border-color: rgba(212,175,55,0.4);
  }
  .email-input::placeholder { color: #56565c; }
  .send-code-btn {
    width: 100%;
    background: linear-gradient(180deg, #d4af37 0%, #b8941f 100%);
    color: #0a0a0c;
    border: none;
    padding: 12px 20px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: transform 0.1s ease, box-shadow 0.2s ease;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.2), 0 2px 12px rgba(212,175,55,0.2);
  }
  .send-code-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.3), 0 4px 20px rgba(212,175,55,0.3);
  }
  .send-code-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    transform: none;
  }
  .link {
    background: none;
    border: none;
    color: #888892;
    font-size: 11px;
    padding: 6px 4px;
    text-align: left;
    cursor: pointer;
    margin-top: 4px;
  }
  .link:hover { color: #d8d8dc; }
  .error {
    color: #d48484;
    font-size: 12px;
    padding: 10px 12px;
    background: rgba(200,100,100,0.08);
    border: 1px solid rgba(200,100,100,0.2);
    border-radius: 8px;
    margin-top: 8px;
  }
</style>
